import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Layout from './components/layout/Layout';
import Login from './components/auth/Login';
import Dashboard from './components/dashboard/Dashboard';
import Devices from './components/devices/Devices';
import DeviceEdit from './components/devices/DeviceEdit';
import DeviceView from './components/devices/DeviceView';
import DeviceViewPage from './components/devices/DeviceViewPage';
import ProductSelect from './components/devices/ProductSelect';
import Repairs from './components/repairs/Repairs';
import RepairNew from './components/repairs/RepairNew';
import RepairView from './components/repairs/RepairView';
import ModuleReport from './components/repairs/ModuleReport';
import Users from './components/users/Users';
import Orders from './components/orders/Orders';
import OrderSerialNumbers from './components/orders/OrderSerialNumbers';
import OrderSettings from './components/orders/OrderSettings';
import DeviceTypesList from './components/catalog/DeviceTypesList';
import DeviceTypeEdit from './components/catalog/DeviceTypeEdit';
import ModulesList from './components/catalog/ModulesList';
import ModuleEdit from './components/catalog/ModuleEdit';
import StatsOverview from './components/stats/StatsOverview';
import DeviceStats from './components/stats/DeviceStats';
import OrderStats from './components/stats/OrderStats';
import RepairStats from './components/stats/RepairStats';
import TimeTracker from './components/time/TimeTracker';
import ProjectList from './components/time/ProjectList';
import TimeStats from './components/stats/TimeStats';
import Accounting from './components/accounting/Accounting';
import PaymentDetail from './components/accounting/PaymentDetail';
import B2BOrders from './components/accounting/B2BOrders';
import B2BOrderDetail from './components/accounting/B2BOrderDetail';
import VascoInvoices from './components/accounting/VascoInvoices';
import GkExport from './components/accounting/GkExport';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.history.scrollRestoration = 'manual'; }, []);
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/devices"
            element={
              <ProtectedRoute>
                <Layout>
                  <Devices />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/devices/select-product"
            element={
              <ProtectedRoute>
                <Layout>
                  <ProductSelect />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/devices/new"
            element={
              <ProtectedRoute>
                <Layout>
                  <DeviceEdit />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/devices/:serialNumber/view"
            element={
              <ProtectedRoute>
                <Layout>
                  <DeviceViewPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/devices/id/:deviceId/view"
            element={
              <ProtectedRoute>
                <Layout>
                  <DeviceViewPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/repairs"
            element={
              <ProtectedRoute>
                <Layout>
                  <Repairs />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/repairs/report"
            element={
              <ProtectedRoute>
                <Layout>
                  <ModuleReport />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/repairs/new"
            element={
              <ProtectedRoute>
                <Layout>
                  <RepairNew />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/repairs/:id/view"
            element={
              <ProtectedRoute>
                <Layout>
                  <RepairView />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <Layout>
                  <Users />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders"
            element={
              <ProtectedRoute>
                <Layout>
                  <Orders />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders/:orderId/serials"
            element={
              <ProtectedRoute>
                <Layout>
                  <OrderSerialNumbers />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders/settings"
            element={
              <ProtectedRoute>
                <Layout>
                  <OrderSettings />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/catalog/products"
            element={
              <ProtectedRoute>
                <Layout>
                  <DeviceTypesList />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/catalog/products/:id/edit"
            element={
              <ProtectedRoute>
                <Layout>
                  <DeviceTypeEdit />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/catalog/modules"
            element={
              <ProtectedRoute>
                <Layout>
                  <ModulesList />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/catalog/modules/:id/edit"
            element={
              <ProtectedRoute>
                <Layout>
                  <ModuleEdit />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/stats"
            element={
              <ProtectedRoute>
                <Layout>
                  <StatsOverview />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/stats/devices"
            element={
              <ProtectedRoute>
                <Layout>
                  <DeviceStats />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/stats/orders"
            element={
              <ProtectedRoute>
                <Layout>
                  <OrderStats />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/stats/repairs"
            element={
              <ProtectedRoute>
                <Layout>
                  <RepairStats />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/stats/time"
            element={
              <ProtectedRoute>
                <Layout>
                  <TimeStats />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/time"
            element={
              <ProtectedRoute>
                <Layout>
                  <TimeTracker />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/time/projects"
            element={
              <ProtectedRoute>
                <Layout>
                  <ProjectList />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounting"
            element={
              <ProtectedRoute allowedRoles={['admin', 'accounting']}>
                <Layout>
                  <Accounting />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounting/payments/:id"
            element={
              <ProtectedRoute allowedRoles={['admin', 'accounting']}>
                <Layout>
                  <PaymentDetail />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounting/b2b-orders"
            element={
              <ProtectedRoute allowedRoles={['admin', 'accounting']}>
                <Layout>
                  <B2BOrders />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounting/b2b-orders/:id"
            element={
              <ProtectedRoute allowedRoles={['admin', 'accounting']}>
                <Layout>
                  <B2BOrderDetail />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounting/gk-export"
            element={
              <ProtectedRoute allowedRoles={['admin', 'accounting']}>
                <Layout>
                  <GkExport />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounting/vasco-invoices"
            element={
              <ProtectedRoute allowedRoles={['admin', 'accounting']}>
                <Layout>
                  <VascoInvoices />
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
